<template>
    <div>
        <b-row>
            <b-col cols="6">
                <b-form-group :label="$t('faculty')">
                    <b-input-group>
                        <div class="label-as-input">{{ getLocaleText(form, 'faculty_name') }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="6">
                <b-form-group :label="$t('department')">
                    <b-input-group>
                        <div class="label-as-input">{{ getLocaleText(form, 'department_name') }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="6">
                <b-form-group :label="$t('student_number')">
                    <b-input-group>
                        <div class="label-as-input">{{ isNotNullValue(form.student_number) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="6">
                <b-form-group :label="$t('name')">
                    <b-input-group>
                        <div class="label-as-input">{{ isNotNullValue(form.name) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="6">
                <b-form-group :label="$t('surname')">
                    <b-input-group>
                        <div class="label-as-input">{{ isNotNullValue(form.surname) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="6">
                <b-form-group :label="$t('email')">
                    <b-input-group>
                        <div class="label-as-input">{{ isNotNullValue(form.email) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="6">
                <b-form-group :label="$t('start_date')">
                    <b-input-group>
                        <div class="label-as-input">{{ isNotNullValue(form.start_date) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="6">
                <b-form-group :label="$t('end_date')">
                    <b-input-group>
                        <div class="label-as-input">{{ isNotNullValue(form.end_date) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="6">
                <b-form-group :label="$t('responsible_name')">
                    <b-input-group>
                        <div class="label-as-input">{{ isNotNullValue(form.responsible_name) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="6">
                <b-form-group :label="$t('responsible_surname')">
                    <b-input-group>
                        <div class="label-as-input">{{ isNotNullValue(form.responsible_surname) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="6">
                <b-form-group :label="$t('responsible_email')">
                    <b-input-group>
                        <div class="label-as-input">{{ isNotNullValue(form.responsible_email) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="6">
                <b-form-group :label="$t('status')">
                    <b-input-group>
                        <div class="label-as-input">{{ form.active_step ? form.active_step.status_name : '-' }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    //Service
    import InternshipApplicationService from '@/services/InternshipApplicationService';

    export default {
        props: {
            formId: {
                type: Number
            }
        },
        data() {
            return {
                form: {
                    faculty_name: null,
                    department: null,
                    program_name: null,
                    student_number: null,
                    responsible_name: null,
                    responsible_surname: null,
                    responsible_email: null,
                    start_date: null,
                    end_date: null,
                }
            }
        },
        async created() {
            await this.get(this.formId)
        },
        computed: {

        },
        methods: {
            get(id) {
                this.formLoading = true;
                InternshipApplicationService.get(id)
                                .then((response) => {
                                    this.form = response.data.data;
                                    this.formLoading = false;
                                })
                                .catch((error) => {
                                    this.showErrors(error)
                                });
            }
        }
    }
</script>
